import * as BannerPrimitive from '@givebutter/primitives/banner';
import { Banner } from '@givebutter/primitives/banner';
import { Button } from '@givebutter/primitives/button';
import { faBank } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useFetchPayoutAccount } from 'assets/js/pages/payouts/useFetchPayoutAccount';
import { ConnectAccountDialog } from 'components/required-checklist/required-items/ConnectAccountDialog';
import { posthogEvents } from 'constants/posthog-events';
import { useAccountLocalStorage } from 'contexts/useAccountLocalStorage';
import { usePosthog } from 'customHooks/usePosthog';

const ConnectPayoutMethodBanner = () => {
    const { data: payoutAccount } = useFetchPayoutAccount();
    const { pushEvent } = usePosthog();

    const { hasDismissedPayoutMethodBanner, setHasDismissedPayoutMethodBanner } =
        useAccountLocalStorage(
            ({ hasDismissedPayoutMethodBanner, setHasDismissedPayoutMethodBanner }) => ({
                hasDismissedPayoutMethodBanner,
                setHasDismissedPayoutMethodBanner,
            }),
        );

    if (hasDismissedPayoutMethodBanner || payoutAccount.data?.merchant_onboarding_complete) {
        return null;
    }

    return (
        <Banner type="none">
            <div className="flex items-center gap-3 text-sm">
                <BannerPrimitive.Icon>
                    <FontAwesomeIcon icon={faBank} className="text-brand-violet-dark" />
                </BannerPrimitive.Icon>
                Link a payout method to publish campaigns & receive donations
            </div>
            <div className="flex flex-col-reverse items-center sm:flex-row sm:gap-2">
                <BannerPrimitive.DismissButton
                    size="sm"
                    className="static text-gray-700"
                    onClick={() => {
                        pushEvent(posthogEvents.CONNECT_PAYOUT_METHOD_BANNER_DISMISSED);
                        setHasDismissedPayoutMethodBanner(true);
                    }}
                >
                    I don't want to fundraise
                </BannerPrimitive.DismissButton>
                <ConnectAccountDialog>
                    <Button
                        variant="outline"
                        size="sm"
                        color="neutral"
                        className="w-full font-medium sm:w-fit"
                        onClick={() => {
                            pushEvent(posthogEvents.CONNECT_PAYOUT_METHOD_BANNER_SELECTED);
                        }}
                    >
                        Connect payout method
                    </Button>
                </ConnectAccountDialog>
            </div>
        </Banner>
    );
};

export { ConnectPayoutMethodBanner };
